module.exports = __webpack_public_path__ + "static/media/ETANG_EQ_PATIO.adf33c4d.webp";